var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmbedStatic = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1H1V3ZM1 5h2v8H2a1 1 0 0 1-1-1V5ZM4 6a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v2H4V6ZM4 9h5v4H5a1 1 0 0 1-1-1V9ZM10 9h5v3a1 1 0 0 1-1 1h-4V9Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmbedStatic);
export default ForwardRef;